import { useDispatch, useSelector } from 'react-redux';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/modal';
import { PrimaryButton } from 'ui/button';
import noop from 'utils/noop';
import { useValidatedDomain } from '../hooks';
import { createTrackingDomainRequest } from '../actions';
import { getIsLoading } from '../selectors';
// import { TrackingDomain } from '../types';

// type ModalProps = {
//   onClose: () => {},
//   trackingDomains: Array<TrackingDomain>,
// };

export const CreateTrackingDomainModal = ({ onClose = noop, trackingDomains = [] }) => {
  const dispatch = useDispatch();
  const [newDomain, setNewDomain, errorMessage] = useValidatedDomain('', trackingDomains);
  const isLoading = useSelector(getIsLoading);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createTrackingDomainRequest(newDomain));
    onClose();
  };

  const hasValidationError = errorMessage.length > 0;
  const isDisabled = hasValidationError || isLoading || newDomain.length === 0;

  return (
    <Modal
      id="createTrackingDomainModal"
      data-test="mailDomains-create-tracking-domain-modal"
      onClose={onClose}
      isModalOpen
    >
      <ModalHeader>Create a new tracking domain</ModalHeader>
      <ModalBody>
        <form id="createNewTrackingDomain" onSubmit={handleSubmit}>
          <FormField
            hasError={hasValidationError}
            errorText={errorMessage}
            key="newTrackingDomain"
            inputId="mailDomains-create-tracking-domain-modal-form"
            labelText="Tracking domain"
            isRequired
          >
            <InputText
              autoFocus
              id="newTrackingDomain"
              value={newDomain}
              error={hasValidationError}
              onChange={(value) => setNewDomain(value)}
              data-test="mailDomains-create-tracking-domain-modal-form-input"
              placeholder="links.mycompany.com"
              required
            />
          </FormField>
        </form>
      </ModalBody>
      <ModalFooter hasCancel onClose={onClose}>
        <PrimaryButton
          isDisabled={isDisabled}
          key="submit"
          type="submit"
          form="createNewTrackingDomain"
          data-test="mailDomains-create-tracking-domain-modal-confirm-button"
        >
          Create
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
